import React, { Component } from 'react';
import { Modal, Button, Form, Input, Row, Col, Checkbox, message, Select } from 'antd';
import './style.less';
import send from '../util/request';
import { getAREA, userAddressWarehouseList } from '../util/api';

const FormItem = Form.Item;
const { Option } = Select;
const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 18,
	},
};
const tailLayout = {
	wrapperCol: { offset: 4, span: 18 },
};
class CpAddressModal extends Component {
	formRef = React.createRef();
	state = {
		countryList: [],
		provinceList: [],
		areaList: [],
		cityList: [],
		warehouseList: [],
		countryName: '',
		provinceName: '',
		cityName: '',
		areaName: '',
	}

	async componentDidMount() {
		const { record } = this.props;
		const { setFieldsValue } = this.formRef.current;
		const { data: { data: { list = [] }, code } } = await userAddressWarehouseList();
		if (+code === 0) {
			this.setState({ warehouseList: list });
		}
		getAREA({
			pid: 0
		}).then(res => {
			const { data, code } = res.data;
			if (code === 0) {
				this.setState({ countryList: data });
				if (Object.keys(record).length !== 0) {
					console.log(record);
					this.handleGetCountry(record.countryId, record.countryName);
					this.handleGetCity(record.provinceId, record.provinceName);
					this.handleGetArea(record.cityId, record.cityName);
					this.handleGetAreaId(record.areaId, record.areaName);

					setFieldsValue({
						username: record.username || '',
						provinceId: record.provinceId || '',
						countryId: record.countryId || '',
						cityId: record.cityId || '',
						warehouse_id: +record.warehouse_id || '',
						areaId: record.areaId || '',
						address: record.address || '',
						phone: record.phone || '',
						isDefault: !!record.isDefault || false,
					});
				}
			}
		});

	}
	componentWillUnmount() {
    this.setState = () => false;
  }
	handleCancel = () => {
		const { resetFields } = this.formRef.current;
		const { hideModal } = this.props;
		resetFields();
		hideModal();
	}
	submit = () => {
		const { validateFields } = this.formRef.current;
		const { record, submitModal } = this.props;
		const { provinceName, countryName, cityName, areaName, } = this.state;
		validateFields().then(res => {
			let url = Object.keys(record).length !== 0 ? '/ipp/user-address/update' : '/ipp/user-address/insert';
			send({
				url,
				method: 'POST',
				data: {
					id: record.id || '',
					username: res.username || '',
					phone: res.phone || '',
					province_id: res.provinceId || '',
					province_name: provinceName || '',
					country_id: res.countryId || '',
					country_name: countryName || '',
					city_id: res.cityId || '',
					warehouse_id: res.warehouse_id || '',
					city_name: cityName || '',
					area_id: res.areaId || '',
					area_name: areaName || '',
					address: res.address || '',
					postal_code: res.postalCode || '031100',
					is_default: res.isDefault === true ? 1 : 0,
				}
			}).then(res => {
				if (res.data && res.data.code === 0) {
					message.success(res.data.msg, .5, submitModal());
				} else {
					message.error(res.data.msg);
				}
			});
		});
	};
	handleGetCountry = (value, option) => {
		getAREA({
			pid: value || ''
		}).then(res => {
			const { data, code } = res.data;
			if (code === 0) {
				this.setState({ provinceList: data, countryName: option.children || option });
			}
		});
		this.formRef.current.setFieldsValue({
			cityId: '',
			areaId: ''
		});
	}
	handleGetCity = (value, option) => {
		getAREA({
			pid: value || ''
		}).then(res => {
			const { data, code } = res.data;
			if (code === 0) {
				this.setState({ cityList: data, provinceName: option.children || option });
			}
		});
		this.formRef.current.setFieldsValue({
			cityId: '',
			areaId: ''
		});
	}
	handleGetArea = (value, option) => {
		getAREA({
			pid: value || ''
		}).then(res => {
			const { data, code } = res.data;
			if (code === 0) {
				this.setState({ areaList: data, cityName: option.children || option });
			}
		});
		this.formRef.current.setFieldsValue({
			areaId: ''
		});
	}
	handleGetAreaId = (value, option) => {
		this.setState({
			areaName: option.children || option
		});
	}
	render() {
		const { provinceList = [], cityList = [], areaList = [], countryList = [], warehouseList = [] } = this.state;

		return (
			<Modal
				title="我的收货地址"
				open={true}
				width={630}
				maskClosable={false}
				wrapClassName="address-modal"
				centered
				footer={[
					<Button
						key="submit"
						type="primary"
						onClick={this.submit}
						htmlType="submit"
						style={{ width: 200, height: 40 }}>
						{'保存'}
					</Button>
				]}
				onCancel={this.handleCancel}
			>
				<Form
					{...layout}
					ref={this.formRef}
				>
					<FormItem
						label="收货人"
						name="username"
						rules={[
							{
								required: true,
								message: '请输入收货人姓名!',
							},
						]}
					>
						<Input placeholder="请输入收货人" />
					</FormItem>
					<FormItem
						label="联系方式"
						name="phone"
						rules={[
							{ required: true, message: '请输入联系方式' },
							{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确联系方式' },
						]}
					>
						<Input placeholder="请输入联系方式" />
					</FormItem>
					<FormItem
						label="地区"
						style={{ marginBottom: 0 }}

					>
						<Row gutter={18}>
							<Col span={8}>
								<FormItem
									noStyle
									shouldUpdate={(prevValues, currentValues) => prevValues.countryId !== currentValues.countryId}
								>
									{({ getFieldValue }) => {
										return <FormItem
											name="countryId"
											rules={[
												{
													required: true,
													message: '请输入国家',
												},
											]}
										>
											<Select
												// disabled={getFieldValue('countryId') === ''}
												onChange={this.handleGetCountry}>
												{
													(countryList || []).map(item => {
														return <Option value={item.id} key={item.id} disabled={item.id !== 3756}>{item.name}</Option>;
													})
												}
											</Select>
										</FormItem>;
									}}
								</FormItem>
							</Col>
							<Col span={8}>
								<FormItem
									name="provinceId"
									rules={[
										{
											required: true,
											message: '请输入省',
										},
									]}
								>
									<Select
										onChange={this.handleGetCity}
									>
										{
											provinceList && provinceList.length > 0 && provinceList.map(item => {
												return <Option value={item.id} key={item.id} >{item.name}</Option>;
											})
										}
									</Select>
								</FormItem>
							</Col>
							<Col span={8}>
								<FormItem
									noStyle
									shouldUpdate={(prevValues, currentValues) => prevValues.provinceId !== currentValues.provinceId}
								>
									{({ getFieldValue }) => {
										return <FormItem
											name="cityId"
											rules={[
												{
													required: true,
													message: '请输入市',
												},
											]}
										>
											<Select
												disabled={getFieldValue('provinceId') === ''}
												onChange={this.handleGetArea}>
												{
													cityList && cityList.length > 0 && cityList.map(item => {
														return <Option value={item.id} key={item.id} >{item.name}</Option>;
													})
												}
											</Select>
										</FormItem>;
									}}
								</FormItem>
							</Col>
							<Col span={8}>
								<FormItem
									noStyle
									shouldUpdate={(prevValues, currentValues) => prevValues.cityId !== currentValues.cityId}
								>
									{({ getFieldValue }) => {
										return <FormItem
											name="areaId"
											rules={[
												{
													required: true,
													message: '请输入区',
												},
											]}
										>
											<Select
												disabled={getFieldValue('cityId') === ''}
												onChange={this.handleGetAreaId}>
												{
													areaList && areaList.length > 0 && areaList.map(item => {
														return <Option value={item.id} key={item.id} >{item.name}</Option>;
													})
												}
											</Select>
										</FormItem>;
									}}
								</FormItem>

							</Col>

						</Row>
					</FormItem>
					<FormItem
						label="详细地址"
						name="address"
						rules={[
							{
								required: true,
								message: '请输入详细地址!',
							},
						]}
					>
						<Input placeholder="请输入详细地址" />
					</FormItem>
					{
						// localStorage.getItem('warehouse_type') === 'WMS' ? <FormItem
						['WMS', 'SAP'].includes(localStorage.getItem('warehouse_type')) ? <FormItem
							label="收货仓库"
							name="warehouse_id"
							rules={[
								{ required: true, message: '请选择收货仓库' },
							]}
						>
							<Select>
								{
									(warehouseList || []).map(item => {
										return <Option value={item.id} key={item.id} >{item.warehouse_name}</Option>;
									})
								}
							</Select>
						</FormItem> : null
					}
					<Form.Item
						{...tailLayout}
						name="isDefault"
						valuePropName="checked"
					>
						<Checkbox>设为默认收货地址</Checkbox>
					</Form.Item>
				</Form>
			</Modal>
		);
	}
}
export default CpAddressModal;